export var ConnectionEvent;
(function (ConnectionEvent) {
    ConnectionEvent["InvalidUrl"] = "invalid:url";
    ConnectionEvent["InvalidMessage"] = "invalid:message:receive";
    ConnectionEvent["Open"] = "socket:open";
    ConnectionEvent["Reset"] = "socket:reset";
    ConnectionEvent["Close"] = "socket:close";
    ConnectionEvent["Error"] = "socket:error";
    ConnectionEvent["Receive"] = "receive:message";
    ConnectionEvent["Notice"] = "receive:notice";
    ConnectionEvent["Send"] = "send:message";
})(ConnectionEvent || (ConnectionEvent = {}));
//# sourceMappingURL=ConnectionEvent.js.map